import { render, staticRenderFns } from "./SingleNumber.vue?vue&type=template&id=2f6cd51d&"
import script from "./SingleNumber.vue?vue&type=script&lang=ts&"
export * from "./SingleNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports